import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';
import { baseReducers, getBaseActions } from "./base";

const name = 'category';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        ...baseReducers,
        resetPopupReceived: state => ({
            ...state,
            isFetching: false
        }),
    }
});

const { _set, requested, failed, itemReceived, itemsReceived, deleteReceived, submitReceived, resetPopupReceived } = slice.actions;

export default slice.reducer;

const { baseSet, baseGet, baseGetAll, baseSubmit } = getBaseActions(requested.type, failed.type);

export const set = payload => baseSet(_set.type, payload);

export const get = id => baseGet(name, itemReceived.type, { id });

export const getAll = data => baseGetAll(name, itemsReceived.type, data);

export const submit = data => baseSubmit(name, submitReceived.type, data);

export const remove = id => ({
    types: [requested.type, deleteReceived.type, failed.type],
    url: getApiUrl(name, 'delete'),
    payload: { id }
});

export const resetPopup = () => ({
    types: [requested.type, resetPopupReceived.type, failed.type],
    url: getApiUrl(name, 'resetpopup')
});